var _excluded = ["borderless", "rounded"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ListView as KendoListView, ListViewFooter, ListViewHeader } from '@progress/kendo-react-listview';
import { borderRadius } from '../../common';
var StyledListView = styled(_ref => {
  var {
      borderless,
      rounded
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(KendoListView, rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n"])), props => css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        ", "\n    "])), props.borderless ? css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            background-color: transparent;\n        "]))) : css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            border-color: ", ";\n            border-radius: ", ";\n            border-style: solid;\n            border-width: 1px;\n            padding: 0.5rem 1rem;\n        "])), props.theme.component.baseBorder, borderRadius(props))));

/**
 * The KendoReact ListView enables you to display a custom layout of data items.
 * The ListView is ideally suited for displaying a list of items in a consistent manner.
 * You can see commonplace examples of its use in the design structures of the Internet,
 * search engine results, tweets from Twitter, Facebook updates, inbox items in Gmail,
 * card lists in Instagram, and so on.
 */
var ListView = props => /*#__PURE__*/React.createElement(StyledListView, props);
ListView.defaultProps = {
  borderless: false,
  className: undefined,
  data: undefined,
  footer: undefined,
  header: undefined,
  item: undefined,
  onScroll: undefined,
  rounded: 'medium',
  style: undefined
};
ListView.propTypes = {
  /**
   * Determines if there should be a border or not.
   */
  borderless: PropTypes.bool,
  /**
   * Sets a class of the ListView DOM element.
   */
  className: PropTypes.string,
  /**
   * Sets the data of the ListView.
   */
  data: PropTypes.arrayOf(PropTypes.shape({})),
  /**
   * Defines the component that will be rendered for ListView footer.
   */
  footer: PropTypes.func,
  /**
   * Defines the component that will be rendered for ListView header.
   */
  header: PropTypes.func,
  /**
   * Defines the component that will be rendered for each item of the data collection.
   */
  item: PropTypes.func,
  /**
   * Fires when the ListView has been scrolled.
   */
  onScroll: PropTypes.func,
  /**
   * Configures the roundness of the ListView.
   * The available options are: 'small' | 'medium' | 'large' | 'full'
   */
  rounded: PropTypes.oneOf(['small', 'medium', 'large', 'full']),
  /**
   * Sets styles to the ListView container.
   */
  style: PropTypes.shape({})
};
export default ListView;
export { ListViewFooter, ListViewHeader };